// shared fns between buy sell, widget and nft order forms
import useBlockchainFilters from "@/composables/filters/useBlockchainFilters";

const { getActiveCoinData, getCurrentCoinDefaultBlockchain } =
  useBlockchainFilters();

export default () => {
  const findBlockchainsByCoin = (
    store,
    form,
    defaultBlockchain,
    blockchainsByCoin
  ) => {
    const selectedBlockchainIsValidWithCoin =
      store.findAllBlockchainCodesByCoins.find(
        (blockchain) => blockchain.value === store.form.blockchain.value
      );

    // if the selected coin also has the selected blockchain, don't update the value
    if (selectedBlockchainIsValidWithCoin) {
      defaultBlockchain.value = store.form.blockchain.value;
    } // use coin's is_default blockchain
    else {
      defaultBlockchain.value = getCurrentCoinDefaultBlockchain(
        getActiveCoinData(store.coinData.data, form.value.coinType)
      );
    }

    blockchainsByCoin.value = store.findAllBlockchainCodesByCoins;
  };

  return {
    findBlockchainsByCoin,
  };
};
